module.exports = __webpack_public_path__ + "static/media/icon-about.3b040bfa.svg";